import { Directive, Inject, InjectionToken, Input, TemplateRef, ViewContainerRef } from '@angular/core';

export const DISABLED_FEATURES: InjectionToken<string[]> =  new InjectionToken<string[]>('please provide the right array for disable flags');

@Directive({
  selector: '[disableFeatures]',
})
export class DisableFeatureDirective {

  // TODO: verify old config. This is stub!
  private _disabledFeatures: string[];

  constructor(private templateRef: TemplateRef<any>,
              private viewContainer: ViewContainerRef, @Inject(DISABLED_FEATURES) private disabledFeatures: string[]) {
    this._disabledFeatures = disabledFeatures;
  }

  @Input() set disableFeatures(_featureNames: string[]) {
    let disabled: boolean = false;
    for (let featureName of _featureNames) {
      if (this._disabledFeatures.includes(featureName)) {
        disabled = true;
      }
    }
    if (disabled) {
      // remove template from DOM
      this.viewContainer.clear();
    } else {
      // add template to DOM
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
